import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import image from "../images"
import "../css/adminCategories.css"

function AdminCategories() {
    return (
        <div>
            <div class="adminCat-bgImg"></div>

            <section className="adminCat-section">

                <div class="row  adminCategory-row">

                    <div class="adminCategory col-lg-6 col-md-6">
                        <Link className="adminCategory-link" to="/petParentTable">
                            <button class="adminCategory-btn">
                                <span className="userTypeCategory">
                                    <img className="userTypeImg  petParentImg" src={image.petParentImg} alt="pet-box" />
                                    <p className="userType">Pet Parent</p>
                                </span>
                            </button>
                        </Link>
                    </div>

                    <div class="adminCategory col-lg-6 col-md-6">
                        <Link className="adminCategory-link" to="/petAdopterTable">
                            <button class="adminCategory-btn">
                                <span className="userTypeCategory">
                                    <img className="userTypeImg  petAdopterImg" src={image.petAdopterImg} alt="pet-hand" />
                                    <p className="userType">Pet Adopter</p>
                                </span>
                            </button>
                        </Link>
                    </div>

                </div>

            </section>

        </div>
    )
}

export default AdminCategories